import React, { useState } from 'react';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';
import { Menu, X } from 'lucide-react';

const navLinks = [
  { href: 'home', label: 'Home' },
  { href: 'work', label: 'Work' },
  { href: 'services', label: 'Services' },
  { href: 'about', label: 'About' },
  { href: 'contact', label: 'Contact' }
];

export const Navigation: React.FC = () => {
  const { scrollToSection } = useSmoothScroll();
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    e.preventDefault();
    scrollToSection(sectionId);
    setIsOpen(false);
  };

  return (
    <>
      {/* Desktop Navigation */}
      <nav className="hidden md:block fixed top-0 right-0 p-8 z-50">
        <ul className="flex gap-12">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={`#${link.href}`}
                onClick={(e) => handleClick(e, link.href)}
                className="text-white hover:text-orange-500 transition-all duration-300 text-lg magic-hover"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Navigation */}
      <div className="md:hidden fixed top-0 right-0 p-4 z-50">
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="text-white p-2 hover:text-orange-500 transition-colors"
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div className="md:hidden fixed inset-0 bg-black/95 z-40 flex items-center justify-center">
          <ul className="flex flex-col gap-8 text-center">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={`#${link.href}`}
                  onClick={(e) => handleClick(e, link.href)}
                  className="text-white hover:text-orange-500 transition-all duration-300 text-2xl"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};